<style scoped lang="scss">
.gene-top-banner{

  .info{
    flex-wrap: wrap;
    text-align: center;
    align-content: center;
    .small-title{
      width: 100%;
      font-size: 2vw;
      letter-spacing: 3vw;
      line-height: 3vw;
      margin-left: 2.8vw;
    }
    .big-title{
      width: 100%;
      font-size: 5.5vw;
      font-weight: bold;
    }
  }
}


</style>
<template>
  <div class="gene-top-banner">
    <div class="banner" v-if="!$route.meta.invisibles">
      <mobile-img :imgAlt="imgAlt ? imgAlt : bigTitle" :url="imgUrl"></mobile-img>
      <div class="info">
        <p class="small-title">{{ smallTitle }}</p>
        <p class="big-title">{{ bigTitle }}</p>
      </div>
    </div>

  </div>
  
</template>

<script>
import MobileImg from '@/components/MobileImg'
export default {
  components: { MobileImg },
  name: 'gene-top-banner',
  props:{
    smallTitle:{
      type: String
    },
    bigTitle:{
      type: String
    },
    imgAlt:{
      type: String
    },
    type:{
      type: String,
      default: 'gene'
    }
  },
  computed:{
    imgUrl(){
      switch(this.type){
        // 基因合成-二级页面：全基因组合成
        case 'gene':
          return 'images/gene_second/banner'
      }
    }

  }

}
</script>



// WEBPACK FOOTER //
// src/views/products/gene-components/geneTopBanner.vue